import clsx from 'clsx';
import { ButtonHTMLAttributes, ReactNode } from 'react';

import MuiButton from '@material-ui/core/Button';

import styles from './Button.module.scss';

/**
 * NOTE - Please use this button from now for design consistency and accessibility.
 * Don't hesitate to modify this button since its currently only has one variant and few implementations.
 */

type ButtonTrackEvent = {
  'element type': 'button';
  'element text': string;
};

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  children: ReactNode;
  onClick?: () => void;
  href?: string;
  disabled?: boolean;
  iconLeft?: JSX.Element;
  iconRight?: JSX.Element;
  trackFunction: ((trackEvent: ButtonTrackEvent) => void) | null;
  className?: string;
  type?: 'button' | 'submit' | 'reset';
  variant?: 'outlined' | 'contained';
  colorVariant?: 'primary' | 'secondary';
};

// TODO: spread the default props so they can actually be used when using this button - problems with some HTML button props messing with mui button props
export const Button = ({
  children,
  onClick,
  href = '',
  disabled,
  trackFunction,
  iconLeft,
  iconRight,
  className,
  type = 'button',
  variant = 'contained',
  colorVariant = 'primary',
}: ButtonProps) => (
  <div className={clsx(styles.container, className)}>
    <MuiButton
      className={clsx(
        styles.myButton,
        variant === 'contained' ? styles.contained : styles.outlined,
        colorVariant === 'secondary' && styles.secondary,
      )}
      variant={variant}
      href={href}
      type={type}
      disabled={disabled}
      onClick={() => {
        if (disabled) {
          return;
        }
        trackFunction?.({
          'element text': children?.toString() ?? '',
          'element type': 'button',
        });
        onClick?.();
      }}
      startIcon={iconLeft}
      endIcon={iconRight}
    >
      {children}
    </MuiButton>
  </div>
);

export default Button;
